import ulku_baykal from "../assets/images/committee/ulku_baykal.jpg";
import sehrinaz_polat from "../assets/images/committee/sehrinaz_polat.jpg";
import hanife_tiryaki_sen from "../assets/images/committee/hanife_tiryaki_sen.jpg";


export const committee_list = [
    {
        name: "Ülkü BAYKAL",
        title: "Prof. Dr.",
        image : ulku_baykal,
        url: "https://akademisyen.arel.edu.tr/portfolio/prof-dr-ulku-baykal"
    },
    {
        name: "Şehrinaz POLAT",
        title: "Doç. Dr.",
        image : sehrinaz_polat,
        url: "https://avesis.istanbul.edu.tr/polats"
    },
    {
        name: "Hanife Tiryaki ŞEN",
        title: "Doç. Dr.",
        image : hanife_tiryaki_sen,
        url: "https://dosya.sbu.edu.tr/CV/HANIFETIRYAKISEN_4728.pdf"
    }
]